import PropTypes from 'prop-types';
import React from 'react';

const Nextjs = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle opacity="0.12" cx="201" cy="733" r="124" fill="url(#paint0_linear_1112_11467)" />
    <circle opacity="0.12" cx="201" cy="733" r="104" fill="url(#paint1_linear_1112_11467)" />
    <mask
      id="mask0_1112_11467"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="97"
      y="629"
      width="208"
      height="208"
    >
      <circle cx="201" cy="733" r="104" fill="#181A1B" />
    </mask>
    <g mask="url(#mask0_1112_11467)">
      <g opacity="0.8">
        <path
          d="M545.99 675.501H528.88C520.633 675.501 512.39 675.501 504.15 675.501C495.763 675.501 487.377 675.475 478.99 675.421C470.417 675.421 461.847 675.378 453.28 675.291C444.46 675.238 435.643 675.168 426.83 675.081L418.04 674.991C411.807 674.911 405.58 674.815 399.36 674.701C389.713 674.521 380.047 674.278 370.36 673.971C360.07 673.641 350.06 673.241 339.79 672.731H339C326.87 672.121 315.42 671.411 303.3 670.551C297.76 670.151 292.217 669.735 286.67 669.301L271.91 668.101L257.15 666.881C253.15 666.555 249.15 666.221 245.15 665.881C239.15 665.421 233.15 664.991 227.1 664.631C221.05 664.271 215.1 663.981 209.01 663.781C197.33 663.411 186.15 663.411 174.47 663.781C168.41 663.981 162.41 664.271 156.38 664.631C150.35 664.991 144.33 665.431 138.32 665.891C134.32 666.205 130.32 666.538 126.32 666.891L111.55 668.071L96.79 669.271C91.25 669.711 85.7033 670.131 80.15 670.531C68.04 671.391 56.59 672.101 44.46 672.721H43.68C33.39 673.241 23.39 673.641 13.1 673.981C3.44001 674.295 -6.22666 674.538 -15.9 674.711C-22.12 674.831 -28.3433 674.931 -34.57 675.011L-43.38 675.111C-52.2 675.205 -61.0233 675.275 -69.85 675.321C-78.4433 675.381 -87.03 675.431 -95.61 675.471L-120.85 675.551H-140"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 827.899H544.821L522.701 827.829C515.334 827.789 507.961 827.743 500.581 827.689C493.201 827.636 485.831 827.569 478.471 827.489C471.091 827.389 463.721 827.279 456.351 827.099C448.981 826.919 441.601 826.699 434.241 826.369C426.881 826.039 419.501 825.639 412.161 825.089C404.821 824.539 397.461 823.829 390.161 822.899C386.507 822.439 382.871 821.913 379.251 821.319C375.631 820.726 372.027 820.029 368.441 819.229C361.295 817.694 354.275 815.622 347.441 813.029C340.744 810.423 334.29 807.234 328.151 803.499C322.116 799.747 316.291 795.667 310.701 791.279C307.891 789.119 305.101 786.929 302.301 784.759C299.501 782.589 296.701 780.419 293.831 778.319C288.093 774.06 282.08 770.185 275.831 766.719C269.435 763.236 262.742 760.328 255.831 758.029C253.671 757.323 251.494 756.656 249.301 756.029C244.326 754.691 239.282 753.623 234.191 752.829C231.717 752.449 229.234 752.116 226.741 751.829C224.241 751.559 221.741 751.359 219.231 751.199C216.491 751.019 213.761 750.899 211.011 750.829L208.611 750.779C206.661 750.779 204.751 750.779 202.801 750.779C201.481 750.779 200.171 750.779 198.851 750.779H195.761H193.081H190.511H187.831H184.741H180.801C178.851 750.779 176.941 750.779 174.991 750.829H172.611C169.881 750.899 167.121 750.999 164.401 751.149C161.851 751.279 159.401 751.459 156.831 751.689C154.261 751.919 151.831 752.219 149.301 752.569C144.225 753.287 139.194 754.288 134.231 755.569C131.891 756.169 129.571 756.849 127.291 757.569C120.297 759.848 113.531 762.774 107.081 766.309C100.794 769.809 94.7619 773.749 89.0308 778.099C86.1708 780.229 83.3808 782.439 80.6008 784.649C77.8208 786.859 75.0808 789.109 72.2908 791.309C66.7375 795.8 60.9277 799.964 54.8908 803.779C48.7067 807.624 42.1746 810.878 35.3808 813.499C28.4849 816.077 21.4006 818.12 14.1908 819.609C10.5808 820.369 6.94078 821.029 3.28078 821.609C-0.379223 822.189 -4.03922 822.689 -7.71922 823.139C-15.0792 824.039 -22.4592 824.719 -29.8492 825.259C-37.2392 825.799 -44.6492 826.199 -52.0692 826.519C-59.4892 826.839 -66.8892 827.049 -74.2992 827.219C-81.7092 827.389 -89.1292 827.509 -96.5392 827.599C-103.949 827.689 -111.369 827.749 -118.779 827.809L-139.949 827.939"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 797.42H544.261L522.101 797.34C514.721 797.34 507.334 797.297 499.941 797.21C492.547 797.123 485.161 797.053 477.781 797C470.381 796.913 462.987 796.787 455.601 796.62C448.201 796.44 440.811 796.21 433.421 795.89C426.031 795.57 418.631 795.15 411.261 794.6C403.891 794.05 396.501 793.35 389.161 792.42C385.491 791.95 381.831 791.42 378.161 790.82C374.491 790.22 370.881 789.54 367.281 788.74C360.102 787.206 353.048 785.134 346.181 782.54C339.413 779.929 332.885 776.734 326.671 772.99C320.566 769.233 314.668 765.15 309.001 760.76C306.151 758.61 303.331 756.42 300.501 754.26C297.671 752.1 294.791 749.91 291.871 747.81C285.987 743.531 279.819 739.655 273.411 736.21C266.778 732.687 259.839 729.772 252.681 727.5C249.681 726.56 246.681 725.74 243.681 725.01C238.961 723.89 234.181 723.01 229.361 722.34C227.441 722.07 225.511 721.84 223.571 721.63C219.911 721.25 216.261 720.99 212.571 720.8C210.091 720.67 207.571 720.58 205.111 720.52C203.161 720.47 201.221 720.43 199.271 720.41H194.191H189.331C187.641 720.41 185.941 720.41 184.251 720.46C182.311 720.46 180.361 720.51 178.411 720.56C175.921 720.63 173.411 720.72 170.951 720.84C167.271 721.03 163.611 721.3 159.951 721.68C158.024 721.88 156.094 722.113 154.161 722.38C149.351 723.03 144.531 723.89 139.811 724.97C136.721 725.68 133.661 726.48 130.641 727.4C123.385 729.606 116.354 732.492 109.641 736.02C103.179 739.469 96.9758 743.383 91.0808 747.73C88.3208 749.73 85.6108 751.82 82.9208 753.92C79.9208 756.25 77.0008 758.59 74.0208 760.92C68.3806 765.395 62.4948 769.552 56.3908 773.37C50.1499 777.188 43.5684 780.418 36.7308 783.02C29.7855 785.606 22.651 787.652 15.3908 789.14C11.7608 789.91 8.10078 790.57 4.39078 791.14C0.680778 791.71 -2.97921 792.23 -6.67921 792.68C-14.0692 793.58 -21.4892 794.26 -28.9192 794.81C-36.3492 795.36 -43.7692 795.75 -51.2092 796.06C-58.6492 796.37 -66.0792 796.6 -73.5192 796.77C-80.9592 796.94 -88.3892 797.05 -95.8192 797.14C-103.249 797.23 -110.679 797.3 -118.109 797.35L-139.949 797.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 705.999H543.911C536.031 705.999 528.154 705.999 520.281 705.999C512.407 705.999 504.457 705.976 496.431 705.929L481.711 705.849L472.301 705.799C464.141 705.739 455.977 705.666 447.811 705.579C439.491 705.486 431.157 705.359 422.811 705.199C414.261 705.029 405.811 704.789 397.211 704.469C388.331 704.139 379.571 703.729 370.701 703.189L369.391 703.099C360.491 702.549 351.751 701.869 342.881 700.999C337.881 700.519 332.881 699.999 327.881 699.379C322.881 698.759 317.941 698.089 312.971 697.379L307.971 696.589C298.331 695.029 289.091 693.239 279.581 691.169C275.127 690.196 270.691 689.196 266.271 688.169L251.731 684.809C246.881 683.709 242.001 682.619 237.131 681.629L233.661 680.949C228.971 680.029 224.281 679.219 219.551 678.539C214.821 677.859 210.071 677.329 205.281 676.969C196.257 676.299 187.195 676.299 178.171 676.969C173.381 677.319 168.641 677.859 163.901 678.539C159.161 679.219 154.481 680.039 149.781 680.949L146.321 681.639C141.451 682.639 136.571 683.709 131.721 684.819C126.871 685.929 122.031 687.069 117.181 688.199C112.751 689.199 108.321 690.199 103.871 691.199C94.3508 693.279 85.1108 695.059 75.4708 696.629C73.8008 696.909 72.1408 697.159 70.4708 697.419C65.4708 698.179 60.5508 698.849 55.5608 699.419C50.5708 699.989 45.5608 700.579 40.5608 701.059C31.6808 701.919 22.9308 702.609 14.0308 703.169L12.7208 703.249C3.85078 703.799 -4.92922 704.249 -13.8092 704.549C-22.3792 704.869 -30.8992 705.109 -39.4692 705.289C-47.8225 705.456 -56.1759 705.586 -64.5292 705.679C-72.7426 705.766 -80.9492 705.836 -89.1492 705.889L-98.4192 705.959L-113.419 706.039L-137.419 706.119H-139.949"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 766.939H539.991C532.511 766.939 525.034 766.912 517.561 766.859C510.087 766.806 502.591 766.766 495.071 766.739C487.591 766.672 480.084 766.592 472.551 766.499L466.771 766.429C461.164 766.349 455.551 766.246 449.931 766.119C442.361 765.939 434.801 765.709 427.231 765.389C419.661 765.069 412.031 764.659 404.441 764.099C396.851 763.539 389.181 762.849 381.581 761.919C377.754 761.459 373.937 760.929 370.131 760.329C366.321 759.719 362.531 759.039 358.771 758.249C351.199 756.7 343.744 754.625 336.461 752.039C331.872 750.384 327.373 748.492 322.981 746.369C320.431 745.149 317.981 743.849 315.471 742.489C308.711 738.749 302.301 734.549 295.971 730.269C292.721 728.079 289.481 725.859 286.221 723.679C282.961 721.499 279.661 719.369 276.291 717.319C274.921 716.479 273.551 715.669 272.161 714.869C266.123 711.383 259.847 708.325 253.381 705.719C250.381 704.529 247.381 703.459 244.381 702.479C238.213 700.522 231.923 698.975 225.551 697.849C223.924 697.549 222.284 697.279 220.631 697.039C217.371 696.549 214.081 696.159 210.801 695.849C206.541 695.449 202.231 695.189 197.951 695.059C193.871 694.949 189.751 694.949 185.671 695.059C181.401 695.189 177.091 695.449 172.831 695.849C169.541 696.159 166.251 696.549 162.991 697.039C161.351 697.279 159.701 697.549 158.071 697.849C151.665 698.979 145.341 700.532 139.141 702.499C136.081 703.499 133.071 704.549 130.141 705.739C123.672 708.345 117.396 711.406 111.361 714.899C109.971 715.699 108.591 716.509 107.221 717.349C103.851 719.399 100.561 721.529 97.2808 723.719C94.0008 725.909 90.7708 728.109 87.5208 730.309C81.1708 734.599 74.7308 738.829 67.9708 742.589C65.5108 743.949 63.0208 745.249 60.4808 746.469C56.0419 748.624 51.4922 750.544 46.8508 752.219C39.4977 754.85 31.9649 756.949 24.3108 758.499C20.5108 759.279 16.6874 759.966 12.8408 760.559C8.99411 761.152 5.13745 761.679 1.27078 762.139C-6.38922 763.059 -14.0792 763.749 -21.7892 764.299C-29.4992 764.849 -37.0992 765.299 -44.7892 765.579C-52.4792 765.859 -60.0392 766.119 -67.6692 766.289C-72.9626 766.416 -78.2559 766.512 -83.5492 766.579L-90.4492 766.669C-98.0092 766.769 -105.573 766.839 -113.139 766.879C-120.706 766.919 -128.249 766.966 -135.769 767.019H-139.949"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 736.501C541.361 736.501 536.741 736.501 532.121 736.501C524.461 736.501 516.794 736.477 509.121 736.431C501.447 736.384 493.741 736.341 486.001 736.301C478.241 736.247 470.481 736.177 462.721 736.091C454.891 735.991 447.061 735.881 439.231 735.701C431.401 735.521 423.391 735.301 415.471 734.981C411.101 734.801 406.711 734.601 402.341 734.361C398.681 734.161 395.014 733.937 391.341 733.691C383.131 733.131 374.991 732.431 366.821 731.511C362.627 731.044 358.451 730.507 354.291 729.901C350.131 729.294 345.981 728.607 341.841 727.841C334.721 726.491 327.681 724.841 320.741 722.841C319.351 722.441 317.971 722.031 316.601 721.601C308.071 718.899 299.707 715.7 291.551 712.021C288.961 710.861 286.391 709.671 283.821 708.461C281.251 707.251 278.711 706.001 276.171 704.771C272.751 703.111 269.341 701.441 265.911 699.771C259.301 696.611 252.761 693.651 245.911 691.001C241.911 689.461 237.911 688.061 233.741 686.821C229.951 685.671 226.121 684.681 222.221 683.821C218.841 683.087 215.431 682.471 211.991 681.971C208.551 681.481 205.081 681.101 201.611 680.861C195.052 680.401 188.469 680.401 181.911 680.861C178.437 681.114 174.981 681.487 171.541 681.981C168.101 682.474 164.687 683.091 161.301 683.831C157.414 684.677 153.574 685.677 149.781 686.831C145.651 688.081 141.621 689.471 137.611 691.021C130.731 693.671 124.191 696.641 117.611 699.801C114.184 701.441 110.767 703.107 107.361 704.801C104.807 706.041 102.254 707.271 99.7008 708.491C97.1308 709.711 94.5608 710.901 91.9708 712.061C83.8046 715.734 75.4302 718.926 66.8908 721.621C65.5108 722.051 64.1308 722.461 62.7408 722.861C55.8008 724.861 48.7408 726.491 41.6208 727.861C37.4808 728.641 33.3208 729.334 29.1408 729.941C24.9608 730.547 20.7641 731.067 16.5508 731.501C8.34078 732.421 0.160776 733.131 -8.07922 733.691C-11.7059 733.944 -15.3326 734.167 -18.9592 734.361C-23.4192 734.601 -27.8692 734.801 -32.3392 734.991C-40.3392 735.311 -48.3192 735.554 -56.2792 735.721C-64.2392 735.887 -72.1359 736.017 -79.9692 736.111C-87.7959 736.204 -95.6226 736.274 -103.449 736.321C-111.276 736.367 -119.046 736.427 -126.759 736.501H-139.949"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 645.02H509.341C500.554 645.02 491.764 645.02 482.971 645.02L466.661 644.97H455.811C446.397 644.97 436.984 644.927 427.571 644.84C417.651 644.78 407.731 644.71 397.811 644.63C389.077 644.557 380.354 644.46 371.641 644.34L365.701 644.25C353.701 644.063 341.674 643.82 329.621 643.52C322.121 643.34 314.617 643.14 307.111 642.92L285.291 642.24C275.751 641.94 266.211 641.62 256.661 641.34C241.921 640.89 227.491 640.52 212.751 640.34C198.551 640.15 184.981 640.16 170.751 640.34C156.001 640.54 141.571 640.92 126.831 641.34C117.291 641.63 107.751 641.95 98.2108 642.25C90.9308 642.49 83.6541 642.717 76.3808 642.93C68.8808 643.157 61.3808 643.363 53.8808 643.55C41.8808 643.85 29.8508 644.097 17.7908 644.29L11.8608 644.38C3.13411 644.507 -5.58922 644.607 -14.3092 644.68C-24.2426 644.78 -34.1692 644.853 -44.0892 644.9C-53.5026 644.96 -62.9192 645.01 -72.3392 645.05H-83.1792L-99.4492 645.1H-125.839H-139.949"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.989 888.889H534.989L512.209 888.809C504.575 888.809 496.945 888.766 489.319 888.679C481.692 888.593 474.025 888.523 466.319 888.469C458.599 888.383 450.879 888.253 443.159 888.079C435.439 887.906 427.652 887.666 419.799 887.359C411.909 887.029 404.059 886.619 396.189 886.069C390.089 885.639 383.999 885.129 377.929 884.499C376.049 884.313 374.175 884.109 372.309 883.889C368.255 883.423 364.219 882.889 360.199 882.289C356.199 881.679 352.199 880.999 348.199 880.219C340.058 878.65 332.022 876.576 324.139 874.009C317.922 871.945 311.821 869.552 305.859 866.839C304.169 866.069 302.479 865.269 300.809 864.459C298.869 863.509 296.939 862.529 295.029 861.539C293.119 860.549 291.209 859.539 289.319 858.539C285.529 856.479 281.789 854.369 278.019 852.279C274.249 850.189 270.349 848.019 266.439 845.979C261.909 843.599 257.359 841.379 252.639 839.319C248.389 837.479 244.089 835.819 239.639 834.319C232.801 832.034 225.806 830.249 218.709 828.979C215.909 828.479 213.089 828.049 210.259 827.709C207.019 827.319 203.759 827.029 200.499 826.839C194.7 826.514 188.887 826.514 183.089 826.839C179.822 827.019 176.565 827.309 173.319 827.709C170.485 828.049 167.665 828.473 164.859 828.979C157.765 830.253 150.773 832.041 143.939 834.329C139.519 835.809 135.209 837.479 130.939 839.329C126.209 841.379 121.669 843.609 117.129 845.979C113.229 848.029 109.389 850.149 105.549 852.289C101.709 854.429 98.0386 856.489 94.2486 858.559C92.3586 859.559 90.4486 860.559 88.5386 861.559C86.6286 862.559 84.6986 863.559 82.7486 864.479C81.0786 865.289 79.3986 866.089 77.6986 866.859C71.735 869.582 65.6295 871.982 59.4086 874.049C51.5067 876.628 43.4509 878.709 35.2886 880.279C31.2886 881.069 27.2886 881.749 23.2186 882.359C19.1486 882.969 15.1086 883.489 11.0386 883.959C9.2086 884.179 7.35861 884.379 5.50861 884.569C-0.651394 885.236 -6.82474 885.763 -13.0114 886.149C-20.9414 886.709 -28.8614 887.149 -36.8114 887.449C-44.7614 887.749 -52.5114 887.999 -60.3714 888.169C-68.2314 888.339 -75.9514 888.469 -83.7314 888.559C-91.5114 888.649 -99.2014 888.719 -106.931 888.769C-114.661 888.819 -122.321 888.869 -130.011 888.909H-139.941"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M545.991 858.4H541.731C534.284 858.4 526.841 858.373 519.401 858.32C511.961 858.267 504.511 858.223 497.051 858.19C489.577 858.143 482.111 858.073 474.651 857.98C467.191 857.887 459.714 857.757 452.221 857.59C444.721 857.423 437.224 857.183 429.731 856.87C424.991 856.67 420.254 856.427 415.521 856.14C412.741 855.97 409.961 855.79 407.201 855.58C399.661 855.02 392.141 854.33 384.651 853.4C380.891 852.94 377.131 852.4 373.401 851.81C369.671 851.22 365.931 850.52 362.241 849.73C354.831 848.177 347.543 846.095 340.431 843.5C333.391 840.886 326.581 837.692 320.071 833.95C313.561 830.22 307.411 826.02 301.371 821.73C300.421 821.06 299.471 820.39 298.531 819.73C295.941 817.88 293.361 816.02 290.751 814.19C288.141 812.36 285.521 810.55 282.841 808.79C276.232 804.409 269.302 800.531 262.111 797.19C260.484 796.45 258.841 795.74 257.181 795.06C250.435 792.329 243.483 790.135 236.391 788.5L234.561 788.1C229.511 787 224.371 786.16 219.211 785.53C215.211 785.04 211.211 784.68 207.211 784.43C203.741 784.21 200.211 784.06 196.761 783.99C193.441 783.92 190.091 783.92 186.761 783.99C183.281 784.06 179.761 784.21 176.311 784.43C172.311 784.69 168.311 785.05 164.311 785.54C159.151 786.17 154.011 787.01 148.951 788.11L147.131 788.52C140.034 790.15 133.079 792.344 126.331 795.08C124.671 795.76 123.021 796.47 121.401 797.21C114.19 800.551 107.241 804.428 100.611 808.81C97.9308 810.56 95.3008 812.36 92.6908 814.19C90.0808 816.02 87.5008 817.88 84.9208 819.73L82.0108 821.81C75.9508 826.12 69.7608 830.38 63.2408 834.15C56.6857 837.941 49.8211 841.169 42.7208 843.8C35.5488 846.401 28.1957 848.474 20.7208 850C16.9808 850.78 13.2208 851.45 9.45078 852.05C5.68078 852.65 1.88078 853.15 -1.91922 853.6C-9.46922 854.51 -17.0492 855.2 -24.6492 855.75C-27.1492 855.93 -29.6492 856.09 -32.1592 856.25C-37.2126 856.55 -42.2759 856.803 -47.3492 857.01C-54.8892 857.33 -62.4326 857.57 -69.9792 857.73C-77.5259 857.89 -85.0526 858.013 -92.5592 858.1C-100.073 858.193 -107.586 858.263 -115.099 858.31C-122.613 858.357 -130.106 858.4 -137.579 858.44L-139.949 858.5"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="20"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="155.336" y="676">
        MEMORY
      </tspan>
    </text>
    <text
      fill="url(#paint2_linear_1112_11467)"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="76"
      fontWeight="800"
      letterSpacing="0em"
    >
      <tspan x="122.457" y="749.6">
        92%
      </tspan>
    </text>
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="18"
      fontWeight="500"
      letterSpacing="0em"
    >
      <tspan x="162.195" y="780.8">
        Address:&#10;
      </tspan>
      <tspan x="157.256" y="803.8">
        0x4553e0
      </tspan>
    </text>
    <g filter="url(#filter0_ddd_1112_11467)">
      <path
        d="M412 342C412 335.373 417.373 330 424 330H1128C1134.63 330 1140 335.373 1140 342V748C1140 754.627 1134.63 760 1128 760H424C417.373 760 412 754.627 412 748V342Z"
        fill="white"
      />
    </g>
    <rect opacity="0.1" x="412" y="550" width="728" height="24" fill="#FD0054" />
    <path
      d="M1037.17 694.17H1056.49V695.711H1038.94V707.306H1055.45V708.847H1038.94V721.577H1056.69V723.118H1037.17V694.17ZM1058.22 694.17H1060.28L1069.37 706.901L1078.67 694.17L1091.32 678L1070.54 708.239L1081.25 723.118H1079.11L1069.37 709.577L1059.59 723.118H1057.5L1068.29 708.239L1058.22 694.17ZM1082.01 695.711V694.17H1104.03V695.711H1093.89V723.118H1092.11V695.711H1082.01ZM1013 694.17H1015.21L1045.74 740L1033.13 723.118L1014.85 696.36L1014.77 723.118H1013V694.17ZM1103.85 721.112C1103.49 721.112 1103.22 720.831 1103.22 720.467C1103.22 720.104 1103.49 719.823 1103.85 719.823C1104.22 719.823 1104.48 720.104 1104.48 720.467C1104.48 720.831 1104.22 721.112 1103.85 721.112ZM1105.59 719.416H1106.54C1106.55 719.931 1106.93 720.277 1107.48 720.277C1108.09 720.277 1108.44 719.905 1108.44 719.208V714.794H1109.41V719.213C1109.41 720.467 1108.68 721.19 1107.49 721.19C1106.36 721.19 1105.59 720.489 1105.59 719.416V719.416ZM1110.67 719.36H1111.63C1111.71 719.953 1112.29 720.329 1113.12 720.329C1113.89 720.329 1114.46 719.926 1114.46 719.373C1114.46 718.897 1114.1 718.611 1113.28 718.416L1112.48 718.222C1111.35 717.958 1110.84 717.412 1110.84 716.495C1110.84 715.383 1111.74 714.643 1113.1 714.643C1114.36 714.643 1115.28 715.383 1115.34 716.434H1114.4C1114.31 715.859 1113.81 715.5 1113.09 715.5C1112.32 715.5 1111.82 715.868 1111.82 716.43C1111.82 716.876 1112.14 717.131 1112.95 717.321L1113.64 717.49C1114.91 717.789 1115.44 718.308 1115.44 719.247C1115.44 720.442 1114.52 721.19 1113.04 721.19C1111.67 721.19 1110.74 720.476 1110.67 719.36V719.36Z"
      fill="black"
    />
    <rect opacity="0.1" x="461" y="367" width="1" height="393" fill="#181A1B" />
    <text
      opacity="0.6"
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="428.184" y="398.938">
        21&#10;
      </tspan>
      <tspan x="428.184" y="419.938">
        22&#10;
      </tspan>
      <tspan x="428.184" y="440.938">
        23&#10;
      </tspan>
      <tspan x="428.184" y="461.938">
        24&#10;
      </tspan>
      <tspan x="428.184" y="482.938">
        25&#10;
      </tspan>
      <tspan x="428.184" y="503.938">
        26&#10;
      </tspan>
      <tspan x="428.184" y="524.938">
        27&#10;
      </tspan>
      <tspan x="428.184" y="545.938">
        28&#10;
      </tspan>
      <tspan x="428.184" y="566.938">
        29&#10;
      </tspan>
      <tspan x="428.184" y="587.938">
        30&#10;
      </tspan>
      <tspan x="428.184" y="608.938">
        31&#10;
      </tspan>
      <tspan x="428.184" y="629.938">
        32&#10;
      </tspan>
      <tspan x="428.184" y="650.938">
        33&#10;
      </tspan>
      <tspan x="428.184" y="671.938">
        34&#10;
      </tspan>
      <tspan x="428.184" y="692.938">
        35&#10;
      </tspan>
      <tspan x="428.184" y="713.938">
        36&#10;
      </tspan>
      <tspan x="428.184" y="734.938">
        37
      </tspan>
    </text>
    <path
      d="M412 342C412 335.373 417.373 330 424 330H1128C1134.63 330 1140 335.373 1140 342V366H412V342Z"
      fill="white"
    />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Poppins"
      fontSize="14"
      fontWeight="600"
      letterSpacing="0em"
    >
      <tspan x="751.457" y="352.9">
        Next.js
      </tspan>
    </text>
    <circle cx="434" cy="348" r="6" fill="#FD0054" />
    <circle cx="454" cy="348" r="6" fill="#FFB31A" />
    <circle cx="474" cy="348" r="6" fill="#00CC21" />
    <rect opacity="0.1" x="412" y="366" width="728" height="1" fill="#181A1B" />
    <text
      fill="#181A1B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="536.449" y="398.938">
        {' '}
        (&#10;
      </tspan>
      <tspan x="486" y="419.938">
        {' '}
      </tspan>
      <tspan x="486" y="440.938">
        {' '}
      </tspan>
      <tspan x="570.082" y="440.938">
        {' '}
      </tspan>
      <tspan x="486" y="461.938">
        {'        '}
        {'{'}websites.
      </tspan>
      <tspan x="662.572" y="461.938">
        ((website){' '}
      </tspan>
      <tspan x="771.879" y="461.938">
        {' '}
        (&#10;
      </tspan>
      <tspan x="486" y="482.938">
        {' '}
      </tspan>
      <tspan x="603.715" y="482.938">
        {' '}
      </tspan>
      <tspan x="696.205" y="482.938">
        {'{'}
      </tspan>
      <tspan x="738.246" y="482.938">
        (
      </tspan>
      <tspan x="839.145" y="482.938">
        ){'}'}{' '}
      </tspan>
      <tspan x="898.002" y="482.938">
        {'{'}website.
      </tspan>
      <tspan x="990.492" y="482.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="503.938">
        {' '}
      </tspan>
      <tspan x="486" y="524.938">
        {' '}
      </tspan>
      <tspan x="679.389" y="524.938">
        {'{'}website.
      </tspan>
      <tspan x="889.594" y="524.938">
        .
      </tspan>
      <tspan x="931.635" y="524.938">
        [
      </tspan>
      <tspan x="948.451" y="524.938">
        ]{'}'}&#10;
      </tspan>
      <tspan x="486" y="545.938">
        {' '}
      </tspan>
      <tspan x="713.021" y="545.938">
        {'{'}website.
      </tspan>
      <tspan x="872.777" y="545.938">
        .
      </tspan>
      <tspan x="923.227" y="545.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="566.938">
        {' '}
      </tspan>
      <tspan x="704.613" y="566.938">
        {'{'}website.
      </tspan>
      <tspan x="864.369" y="566.938">
        .
      </tspan>
      <tspan x="906.41" y="566.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="587.938">
        {' '}
      </tspan>
      <tspan x="729.838" y="587.938">
        {'{'}website.
      </tspan>
      <tspan x="889.594" y="587.938">
        .
      </tspan>
      <tspan x="956.859" y="587.938">
        {'}'}&#10;
      </tspan>
      <tspan x="486" y="608.938">
        {' '}
      </tspan>
      <tspan x="486" y="629.938">
        {' '}
      </tspan>
      <tspan x="486" y="650.938">
        {'         '}
        )){'}'}&#10;
      </tspan>
      <tspan x="486" y="671.938">
        {' '}
      </tspan>
      <tspan x="544.857" y="671.938">
        /
      </tspan>
      <tspan x="486" y="692.938">
        {' '}
      </tspan>
      <tspan x="528.041" y="692.938">
        /
      </tspan>
      <tspan x="486" y="713.938">
        {' '}
        );&#10;
      </tspan>
      <tspan x="486" y="734.938">
        {'}'};
      </tspan>
    </text>
    <text
      fill="#FD0054"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="486" y="398.938">
        return
      </tspan>
    </text>
    <text
      fill="#1A9900"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="528.041" y="419.938">
        LayoutMain
      </tspan>
      <tspan x="544.857" y="440.938">
        div
      </tspan>
      <tspan x="578.49" y="482.938">
        div
      </tspan>
      <tspan x="595.307" y="503.938">
        Page&#10;
      </tspan>
      <tspan x="586.898" y="629.938">
        div
      </tspan>
      <tspan x="553.266" y="671.938">
        div
      </tspan>
      <tspan x="536.449" y="692.938">
        LayoutMain
      </tspan>
    </text>
    <text
      fill="#8152E0"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="637.348" y="461.938">
        map
      </tspan>
      <tspan x="704.613" y="482.938">
        clsx
      </tspan>
    </text>
    <text
      fill="#001A9B"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="519.633" y="419.938">
        &#60;
      </tspan>
      <tspan x="612.123" y="419.938">
        &#62;&#10;
      </tspan>
      <tspan x="536.449" y="440.938">
        &#60;
      </tspan>
      <tspan x="578.49" y="440.938">
        className=
      </tspan>
      <tspan x="1032.53" y="440.938">
        &#62;&#10;
      </tspan>
      <tspan x="755.062" y="461.938">
        =&#62;
      </tspan>
      <tspan x="570.082" y="482.938">
        &#60;
      </tspan>
      <tspan x="612.123" y="482.938">
        className=
      </tspan>
      <tspan x="746.654" y="482.938">
        &#39;flex-none&#39;
      </tspan>
      <tspan x="864.369" y="482.938">
        key=
      </tspan>
      <tspan x="973.676" y="482.938">
        id
      </tspan>
      <tspan x="586.898" y="503.938">
        &#60;
      </tspan>
      <tspan x="603.715" y="524.938">
        pageData=
      </tspan>
      <tspan x="755.062" y="524.938">
        attributes.pages
      </tspan>
      <tspan x="898.002" y="524.938">
        data
      </tspan>
      <tspan x="940.043" y="524.938">
        0
      </tspan>
      <tspan x="603.715" y="545.938">
        websiteTitle=
      </tspan>
      <tspan x="788.695" y="545.938">
        attributes
      </tspan>
      <tspan x="881.186" y="545.938">
        title
      </tspan>
      <tspan x="603.715" y="566.938">
        websiteSlug=
      </tspan>
      <tspan x="780.287" y="566.938">
        attributes
      </tspan>
      <tspan x="872.777" y="566.938">
        slug
      </tspan>
      <tspan x="603.715" y="587.938">
        websiteFavicon=
      </tspan>
      <tspan x="805.512" y="587.938">
        attributes
      </tspan>
      <tspan x="898.002" y="587.938">
        favicon
      </tspan>
      <tspan x="586.898" y="608.938">
        /&#62;&#10;
      </tspan>
      <tspan x="570.082" y="629.938">
        &#60;/
      </tspan>
      <tspan x="612.123" y="629.938">
        &#62;&#10;
      </tspan>
      <tspan x="536.449" y="671.938">
        &#60;
      </tspan>
      <tspan x="578.49" y="671.938">
        &#62;&#10;
      </tspan>
      <tspan x="519.633" y="692.938">
        &#60;
      </tspan>
      <tspan x="620.531" y="692.938">
        &#62;&#10;
      </tspan>
    </text>
    <text
      fill="#00CCCC"
      xmlSpace="preserve"
      style={{ whiteSpace: 'pre' }}
      fontFamily="Roboto Mono"
      fontSize="14"
      letterSpacing="0em"
    >
      <tspan x="662.572" y="440.938">
        &#34;flex flex-nowrap py-28 px-8 gap-x-28 w-max&#34;
      </tspan>
    </text>
    <path
      d="M412 563L200.898 563L200.898 601M200.898 601L210.523 589.375M200.898 601L191.273 589.375"
      stroke="#181A1B"
      strokeWidth="2"
    />
    <defs>
      <filter
        id="filter0_ddd_1112_11467"
        x="372"
        y="310"
        width="808"
        height="510"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_11467" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_11467"
          result="effect2_dropShadow_1112_11467"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_11467"
          result="effect3_dropShadow_1112_11467"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_11467"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_11467"
        x1="325"
        y1="609"
        x2="77"
        y2="857"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21627" stopColor="#FFE600" />
        <stop offset="0.597222" stopColor="#FD6A00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1112_11467"
        x1="305"
        y1="629"
        x2="97"
        y2="837"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21627" stopColor="#FFE600" />
        <stop offset="0.597222" stopColor="#FD6A00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1112_11467"
        x1="281"
        y1="685"
        x2="116.807"
        y2="747.317"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.166667" stopColor="#FFE600" />
        <stop offset="0.84375" stopColor="#FD6A00" />
      </linearGradient>
    </defs>
  </svg>
);

Nextjs.propTypes = {
  className: PropTypes.string,
};

Nextjs.defaultProps = {
  className: null,
};

export default Nextjs;
